'use strict';
module.exports = require('../../full/set/symmetric-difference');
